import { useEffect, useState } from 'react';

const useReposition = (targetElementId?: string) => {
  const [position, setPosition] = useState({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  });

  useEffect(() => {
    const targetElement = targetElementId
      ? document.getElementById(targetElementId)
      : document.body;

    if (!targetElement) return undefined;

    const reposition = () => {
      const { top, left, right, bottom } =
        targetElement.getBoundingClientRect();
      const bodyBoundingClientRect = document.body.getBoundingClientRect();
      if (targetElement.scrollHeight > window.innerHeight) return;
      setPosition({
        top,
        left: left - bodyBoundingClientRect.left,
        right:
          document.body.clientWidth - (right - bodyBoundingClientRect.left),
        bottom:
          document.body.clientHeight - (bottom - bodyBoundingClientRect.top),
      });
    };

    reposition();

    window.addEventListener('resize', reposition);
    window.visualViewport?.addEventListener('resize', reposition);
    return () => {
      window.removeEventListener('resize', reposition);
      window.visualViewport?.removeEventListener('resize', reposition);
    };
  }, [targetElementId]);

  return position;
};

export default useReposition;
